// Pretty much what it says on the tin. Helper function to capitalize a string. Returns an empty string if the input is not a string.
export const capitalize = (str) => {
  if (typeof str !== 'string') {
    // Return an empty string if the input is not a string
    return '';
  }

  return str
    .split(' ')
    .map(word => 
      word
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join('-')
    )
    .join(' ');
}

